import {ComponentProps, PropsWithChildren, ReactNode} from "react";
import {FormControl, FormField, FormItem, FormLabel, FormMessage} from "@/components/ui/form";

export interface LabelFieldProps extends PropsWithChildren{
    name: string
    label?: string | ReactNode | false
    hideError?: boolean
    containerClassName?: ComponentProps<'div'>["className"]
}

export function LabelField({label, name, children, containerClassName, hideError}: LabelFieldProps) {
    return (
        <FormField name={name}>
            <FormItem className={containerClassName}>
                {label && <FormLabel>
                    {label}
                </FormLabel>}
                <FormControl>
                    {children}
                </FormControl>
                {!hideError! && <FormMessage/>}
            </FormItem>
        </FormField>
    )
}

LabelField.displayName = "LabelField";

//        <div className={cn("space-y-2", containerClassName)}>
//             {label && <Label htmlFor={name}>{label}</Label>}
//             {children}
//             {!hideError! && <ErrorField name={name}/>}
//         </div>
